


















































import { Component, Vue } from 'vue-property-decorator'
import Slick from 'vue-slick'
import * as Cutting from '@/assets/scripts/CuttingSliderModule'

@Component({
	name: 'CusttingSlider',
	components: { Slick },
})
export default class Vasilkov extends Vue {
	data() {
		return {
			title: 'Cutting slider',
			SlickOptions: {
				 dots: true,
				 infinite: true,
				 speed: 1500,
				 fade: true,
				 waitForAnimate: true,
				 cssEase: 'ease-in-out',
				responsive: [
					// You can unslick at a given breakpoint now by adding:
					// settings: "unslick"
					// instead of a settings object
				]
			}
		}
	}
	mounted() {
		new Cutting.cuttingSliderModule(null, null, null)
	}
	runEvent(event, slick) {
		new Cutting.cuttingSliderModule(event, slick, event.type)
	}

}
